import { IonBadge, IonChip, IonCol, IonDatetime, IonGrid, IonItem, IonItemDivider, IonLabel, IonRow, IonSelect, IonSelectOption, IonText, useIonViewDidEnter, useIonViewWillLeave } from '@ionic/react'
import jsonata from 'jsonata'
import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'
import { ConfigContext } from '../../contexts/ConfigContext'
import db from '../../resources/db'
import { calcSalePurchase } from '../Graphs/SalesGraph'


const ProfitLoss = () => {

    const { getSalesAmount, getPurchaseAmount, getStocksValue, getStocks, getExpenseAmount, getInvoices, getPurchase } = useContext(ConfigContext);
    
    const [sales, setsales] = useState(0)
    const [purchase, setpurchase] = useState(0)
    const [days, setDays] = useState(0)
    const [fromDate, setFromDate] = useState(moment().toDate())
    const [toDate, setToDate] = useState(moment().add(1, 'days').toDate())

    const [Stocks, setStocks] = useState([])
    const [StocksValue, setStocksValue] = useState(0)
    const [Expense, setExpense] = useState(0)

    useEffect(() => {
        Promise.all([getInvoices(), getPurchase()]).then(([invoices, purchase]) => {
            const x = calcSalePurchase(invoices, purchase, fromDate, toDate)
            console.log(x);
            let res = jsonata('$sum($.sale)').evaluate(x);
            let res1 = jsonata('$sum($.purchase)').evaluate(x);
            setsales(res);
            setpurchase(res1)
        })

        getStocks().then(stocks => {
            setStocks(stocks)
        })
        getStocksValue().then(res => {
            setStocksValue(res)
        })
        getExpenseAmount().then(res => {
            setExpense(res)
        })
        getSalesAmount().then(res => {
            setsales(res)
        })
        getPurchaseAmount().then(res => {
            setpurchase(res)
        });

        return () => {
            setsales(0)
            setpurchase(0)
            setDays(0)
            setFromDate(moment().toDate())
            setToDate(moment().add(1, 'days').toDate())
            setStocks([])
            setStocksValue(0)
            setExpense(0)   
        }
    }, [fromDate, toDate, getExpenseAmount, getInvoices, getPurchase, getPurchaseAmount, getSalesAmount, getStocks, getStocksValue])


    let open = jsonata("$sum(log[type='Opening Stock'].(rate * quantity))").evaluate(Stocks);

    let opening = open ? open : 0;
    let closing  = StocksValue;
    let grossProfit = sales - purchase - opening + closing;
    let expenses = Expense;
    let netProfit = grossProfit - expenses;
    let grossProfitPercent = (grossProfit / purchase) * 100;

    

    // console.log(Stocks);
    
    return (
        <div>
            <IonGrid>
                <h2>Profit & Loss </h2>
                <IonItem>
                    <IonCol>
                        <IonSelect interface='popover' value={days} onIonChange={e=> { 
                            let n = e.target.value;
                            setDays(n)
                            let from = new Date(Date.now() - n * 24 * 60 * 60 * 1000);
                            setFromDate(from);
                            console.log(days, from, toDate);
                        }}>
                            <IonSelectOption value={0}>Today</IonSelectOption>
                            <IonSelectOption value={7}>This week</IonSelectOption>
                            <IonSelectOption value={30}>This month</IonSelectOption>
                            <IonSelectOption value={365}>This year</IonSelectOption>
                        </IonSelect>
                    </IonCol>
                    <IonCol>
                        <IonLabel>From</IonLabel>
                        {/* <IonDatetime id='date' value={fromDate.toUTCString()} onIonChange={e => setFromDate(new Date(e.target.value))} ></IonDatetime> */}
                        <input type='date' max={moment(toDate).format('YYYY-MM-DD')} value={moment(fromDate).format('YYYY-MM-DD')} onChange={e => setFromDate(new Date(e.target.value))} />
                    </IonCol>
                    <IonCol>
                        <IonLabel>To</IonLabel>
                        {/* <IonDatetime id='date' value={toDate.toUTCString()} onIonChange={e => setToDate(new Date(e.target.value))} ></IonDatetime> */}
                        <input type='date' min={moment(fromDate).format('YYYY-MM-DD')} value={moment(toDate).format('YYYY-MM-DD')} onChange={e => setToDate(new Date(e.target.value))} />
                    </IonCol>
                </IonItem>
                <IonRow>
                    <IonCol>
                        <IonItem lines='none'>Sales (+)</IonItem>
                        <IonItem lines='none'>Purchase (-)</IonItem>

                        <IonItem lines='none'>Opening Stock (-)</IonItem>
                        <IonItem lines='none'>Closing Stock (+)</IonItem>

                    </IonCol>
                    <IonCol>
                        <IonItem lines='none'>{ (sales).toFixed(2) }</IonItem>
                        <IonItem lines='none'>{ (purchase.toFixed(2)) }</IonItem>

                        <IonItem lines='none'>{ (opening).toFixed(2) }</IonItem>
                        <IonItem lines='none'>{ (closing).toFixed(2) }</IonItem>
                    </IonCol>
                </IonRow>


                <IonItem>
                    <IonCol>
                        <h3><IonLabel color={grossProfit > 0 ? 'success' : 'danger'}>
                            {grossProfit > 0 ? "Gross Profit" : "Gross Loss"}
                        </IonLabel></h3>
                    </IonCol>
                    <IonCol>
                        <h4><IonLabel color={grossProfit > 0 ? 'success' : 'danger'}>Rs. {(grossProfit).toFixed(2)}
                            <IonBadge color={grossProfit > 0 ? 'success' : 'danger'} >{grossProfitPercent.toFixed(2)}%</IonBadge>
                        </IonLabel></h4>
                    </IonCol>
                </IonItem>
                <IonRow>
                    <IonCol>
                        <IonItem lines='none'>Other Income (+)</IonItem>
            
                        <IonItem lines='none'><h4>Indirect Expenses (-)</h4></IonItem>
                        <IonItem lines='none'>Expenses (-)</IonItem>

                    </IonCol>
                    <IonCol>
                        <IonItem lines='none'>{ 0 }</IonItem>
                        <IonItem lines='none'>{  }</IonItem>
                        <IonItem lines='none'>{ (expenses.toFixed(2)) }</IonItem>
                    </IonCol>
                </IonRow>

                <IonItem>
                    <IonCol>
                        <h3><IonLabel color={netProfit > 0 ? 'success' : 'danger'}>
                            {netProfit > 0 ? "Net Profit" : "Net Loss"}
                        </IonLabel></h3>
                    </IonCol>
                    <IonCol>
                        <h4><IonLabel color={netProfit > 0 ? 'success' : 'danger'}>Rs. {(netProfit).toFixed(2)}</IonLabel></h4>
                    </IonCol>
                </IonItem>
            </IonGrid>

        </div>
    )
}

export default ProfitLoss
